export const is_with_facing = (facing) => {
    const excludeFromFacing = ['Нет', 'Черновая отделка', 'Строительная'];
    return !excludeFromFacing.includes(facing);
};
